<div>
  <div class="container-fluid clearfix">
    <span class="subheader">INDEX ARCHIVING</span>
    <h1>Manage {{pageTitle}}</h1>
  </div>
  <nav class="nav" mat-tab-nav-bar (selectedTabChanges)="onTabChange($event)">
    <div class="box-nav">
      <a mat-tab-link *ngFor="let tab of tabsList" [routerLink]="tab.route" [active]="rla.isActive"
        #rla="routerLinkActive" routerLinkActive>
        {{ tab.name }}
      </a>
    </div>
  </nav>

  <div class="wrapper">
    <div class="sidebar">

      <mat-card class="mat-sidebar">
        <div class="create-station">
          <div></div>
          <div class="align-field-station">
            <div class="text-name">{{pageTitle}}</div>
          </div>

          <div class="align-field-button">
            <button data-testid="add-station" mat-icon-button (click)="createEvent()">
              <mat-icon color="primary">add_circle</mat-icon>
            </button>
          </div>
        </div>
        <div class="list-sidebar">
          <app-sidebar-station *ngIf="listStationSideBar.length > 0" [listData]="listStationSideBar" [page]="pageTitle"
          ></app-sidebar-station>
        </div>
      </mat-card>
    </div>

    <div class="content">

      <ng-container>
        <router-outlet></router-outlet>
      </ng-container>
    </div>
  </div>
</div>
<ihm-loading-indicator></ihm-loading-indicator>